import { render, staticRenderFns } from "./changeFund.vue?vue&type=template&id=6629f2e5"
import script from "./changeFund.vue?vue&type=script&lang=js"
export * from "./changeFund.vue?vue&type=script&lang=js"
import style0 from "./changeFund.vue?vue&type=style&index=0&id=6629f2e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports